import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { appendSerialisedHttpParams, ENVIRONMENT, HateoasMultipleResponseObject } from '@scisys-uim/uim-common';
import { Observable } from 'rxjs';
import { TextSectionServiceBase } from './text-section.service.base';
import { TextSection } from 'assets-model';


@Injectable({
  providedIn: 'root'
})
export class TextSectionService extends TextSectionServiceBase {
  constructor(protected http: HttpClient, @Inject(ENVIRONMENT) protected environment: any) {
    super(http, environment);
  }

  public findByIds(ids: string[]): Observable<HateoasMultipleResponseObject<TextSection>> {

    var params = appendSerialisedHttpParams(ids, 'id');

    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<TextSection>>(this.serviceBaseUrl + '/findByIds', {
      params: params
    }));
  }

}



